var dict = {
  // Catalan
  ca: ['zero', 'un', 'dos', 'tres', 'quatre', 'cinc', 'sis', 'set', '[vh]uit', 'nou', 'deu'],
  // English
  en: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'],
  // Spanish
  es: ['cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez'],
  // French
  fr: ['z[ée]ro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix'],
  // German
  de: ['null', 'eins', 'zwei', 'drei', 'vier', 'funf', 'sechs', 'sieben', 'acht', 'neun', 'zehn'],
  // Italian
  it: ['zero', 'uno', 'due', 'tre', 'quattro', 'cinque', 'sei', 'sette', 'otto', 'nove', 'dieci'],
  // Portuguese
  pt: ['zero', 'um', 'dois', 'tr[eê]s', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove', 'dez'],
  // Russian
  ru: ['нуль', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять', 'десять'],
};

function recognizeNaturalNumbers(sentence, language) {

  language = language || 'en';
  const reference = language && dict[language];
  const pattern = reference
    ? `\\b(\\d+|${reference.join('|')})\\b`
    : '\\b(\\d+)\\b';

  const regex = new RegExp(pattern, 'gi');
  let current;
  const result = [];

  // eslint-disable-next-line no-cond-assign
  while ((current = regex.exec(sentence)) !== null) {
    const number = current[1];
    if (number.match(/\d+/)) {
      result.push(parseInt(number, 10));
    } else {
      reference.some(function (pattern2, idx) {
        const regex2 = new RegExp(pattern2, 'i');
        if (number.match(regex2)) {
          result.push(idx);
          return true; // break
        }
        return false;
      });
    }
  }

  return result;
}

export { recognizeNaturalNumbers as r };
